import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { saveProfileData } from '../../Api';
import Icon from '../../assets/images/edit-icon.svg';
import './Profil.css';

// Function to sanitize inputs to prevent XSS
function sanitizeInput(input) {
  const doc = new DOMParser().parseFromString(input, 'text/html');
  return doc.body.textContent || "";
}

function Profil() {
  const [isEditable, setIsEditable] = useState({
    nama: false,
    email: false,
    hp: false,
    password: false,
  });
  const profilx = JSON.parse(localStorage.getItem('user'));
  const [profileData, setProfileData] = useState(profilx);

  const handleEditClick = (field) => {
    if (field === 'img_path') {
      document.getElementById('profile-image-input').click();
    } else {
      setIsEditable((prevState) => ({
        ...prevState,
        [field]: true,
      }));
    }
  };

  const handleSave = async () => {
    if (profileData.password && profileData.password.length < 6) {
      Swal.fire({
        icon: 'error',
        title: 'Password too short',
        text: 'Password must be at least 6 characters long.',
      });
      return;
    }
  
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!emailRegex.test(profileData.email)) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid email format',
        text: 'Please enter a valid email address.',
      });
      return;
    }
  
    // Sanitize inputs before saving
    const sanitizedProfileData = {
      id:sanitizeInput(profileData.id),
      nama: sanitizeInput(profileData.nama),
      email: sanitizeInput(profileData.email),
      hp: sanitizeInput(profileData.hp),
      password: sanitizeInput(profileData.password), // sanitize password
    };
  
    // Remove password if it's empty or undefined
    if (!sanitizedProfileData.password || sanitizedProfileData.password === "undefined") {
      delete sanitizedProfileData.password;
    }
  
    try {
      const updatedProfileData = { ...sanitizedProfileData };
     
  
      const data = await saveProfileData(updatedProfileData);
  
      let successMessage = data.success;
      if (data.emailChanged || data.passwordChanged) {
        successMessage += '. You will be logged out after clicking OK.';
      }
  
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: successMessage,
      }).then(() => {
        setProfileData(data.user);
        localStorage.setItem('user', JSON.stringify(data.user));
  
        if (data.emailChanged || data.passwordChanged) {
          localStorage.clear();
          window.location.href = '/';
        }
      });
    } catch (error) {
      const errorMessage =
        error.response?.data?.error || 'An unexpected error occurred';
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage,
      });
    }
  
    setIsEditable({
      nama: false,
      email: false,
      hp: false,
      password: false,
    });
   
  };
  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const sanitizedValue = sanitizeInput(value); // Sanitize the input
    setProfileData({
      ...profileData,
      [name]: sanitizedValue,
    });
  };



  return (
    <div className="profilpage">
     

      <div className="profile-details">
        <div className="input-group">
          <label>Name</label>
          <div className="input-with-icon">
            <input
              type="text"
              name="nama"
              value={profileData.nama}
              onChange={handleInputChange}
              disabled={!isEditable.nama}
            />
            <button
              onClick={() => handleEditClick('nama')}
              className="edit-icon"
            >
              <img src={Icon} alt="edit" />
            </button>
          </div>
        </div>
        <div className="input-group">
          <label>Email</label>
          <div className="input-with-icon">
            <input
              type="email"
              name="email"
              value={profileData.email}
              onChange={handleInputChange}
              disabled={!isEditable.email}
            />
            <button
              onClick={() => handleEditClick('email')}
              className="edit-icon"
            >
              <img src={Icon} alt="edit" />
            </button>
          </div>
        </div>
        <div className="input-group">
          <label>Phone Number</label>
          <div className="input-with-icon">
            <input
              type="text"
              name="hp"
              value={profileData.hp}
              onChange={handleInputChange}
              disabled={!isEditable.hp}
            />
            <button
              onClick={() => handleEditClick('hp')}
              className="edit-icon"
            >
              <img src={Icon} alt="edit" />
            </button>
          </div>
        </div>
       
        <div className="input-group">
          <label>Password</label>
          <div className="input-with-icon">
            <input
              type="password"
              name="password"
              value={profileData.password || ''}
              onChange={handleInputChange}
              disabled={!isEditable.password}
              placeholder="Kosongkan jika tidak ingin ganti password"
            />
            <button
              onClick={() => handleEditClick('password')}
              className="edit-icon"
            >
              <img src={Icon} alt="edit" />
            </button>
          </div>
        </div>
        {isEditable.nama ||
        isEditable.email ||
        isEditable.hp ||
        isEditable.password ? (
          <button onClick={handleSave} className="save-button">
            Save Change
          </button>
        ) : null}
      </div>
    </div>
  );
}

export default Profil;
